import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Icon from 'components/common/Icon/Icon'
import Text from 'components/common/Text/Text'
import Link from 'components/common/Link/Link'
import Theme from 'components/common/Theme/Theme'
import Media from 'components/common/Media'
import Mixin from 'components/common/Mixin'
import Button from 'components/common/Button/Button'

const CompareTrayItem = ({
  brandLogoUrl,
  handleRemove,
  imageUrl,
  skuId,
  tireDetailUrl,
  tireLineName
}) =>
  <Wrapper>
    {
      skuId ?
        <Fragment>
          <Tire data-at-comparetrayitem-img src={ `${imageUrl}?$BOT-TireSearchResultCompareTray-Tire-Desktop-w80$` } />
          <ProductInfo>
            <Link to={ tireDetailUrl } data-at-comparetrayitem-brand>
              <BrandLogo src={ `${brandLogoUrl}?$BOT-TireSearchResultCompareTray-Brand-Desktop-h20$` } />
            </Link>
            <TireLine data-at-comparetrayitem-name to={ tireDetailUrl }>{ tireLineName }</TireLine>
          </ProductInfo>
          <Media.Desktop>
            <RemoveItemButton link data-at-comparetrayitem-close onClick={ handleRemove }>
              <RemoveIcon asset="menu-close" alt={ `Remove ${tireLineName}` } />
            </RemoveItemButton>
          </Media.Desktop>
          <Media.Mobile>
            <RemoveItemButton link data-at-comparetrayitem-close onClick={ handleRemove }>
              <RemoveIcon asset="icon-circle-close" alt={ `Remove ${tireLineName}` } />
            </RemoveItemButton>
          </Media.Mobile>
        </Fragment> :
        <Empty data-at-comparetray-add>Add a Product</Empty>
    }
  </Wrapper>

export default CompareTrayItem

CompareTrayItem.propTypes = {
  brandLogoUrl: PropTypes.string,
  handleRemove: PropTypes.func,
  imageUrl: PropTypes.string,
  skuId: PropTypes.string,
  tireDetailUrl: PropTypes.string,
  tireLineName: PropTypes.string
}

const Wrapper = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-around;
  width: calc(100% / 3);
  height: 100%;
  padding: 0 3%;
  text-align: center;
  vertical-align: top;
  background-color: ${Theme.colors.white};
  ${Media.desktop`
    display: inline-block;
    width: calc(100% / 3);
    padding: 0 11px;
    background-color: transparent;
    border-right: 1px solid ${Theme.colors.light_grey};
    ${Mixin.middle()}
  `}
  ${Media.mobile`
    & + & {
      margin-left: 1px;
    }
  `}
`

const Tire = styled.img`
  display: inline-block;
  width: 80px;
  height: 80px;
  margin-right: 10px;
  vertical-align: middle;
  ${Mixin.desktopOnly()}
`

const ProductInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  flex-grow: 6;
  min-height: 60%;
  text-align: left;
  vertical-align: middle;
  ${Media.desktop`
    display: inline-block;
    width: calc(100% - 90px);
    ${Mixin.middle()} 
  `}
`

const BrandLogo = styled.img`
  display: block;
  max-width: 100%;
  max-height: 20px;
  min-height: 8px;
  ${Media.desktop`
    margin-bottom: 10px;
  `}
`

const TireLine = styled(Link)`
  font-weight: 600;
  color: ${Theme.colors.black};
  ${Media.mobile`
    max-height: 33px;
    text-align: center;
    font-size: 10px;
    text-decoration: underline;
    overflow: hidden;
  `}
`

const RemoveItemButton = styled(Button)`
  width: 16px;

  && {
    padding: 0;
  }

  ${Media.desktop`
    position: absolute;
    top: 13px;
    right: 16px;
    width: 10px;
    line-height: 10px;
  `}
  ${Media.mobile`
    display: flex;
    flex-direction: row;
    flex-grow: 4;
    align-items: center;
    justify-content: center;
    width: 100%;
    line-height: 16px;
  `}
`

const RemoveIcon = styled(Icon)`
  width: 10px;
  ${Media.mobile`
    width: 16px;
  `}
`

const Empty = styled(Text)`
  text-align: center;
  font-size: 10px;
  color: ${Theme.colors.medium_grey};
  ${Media.desktop`
    font-size: 14px;
    line-height: 140px;
  `}
`
